export default __webpack_public_path__ + "static/media/footer-bg-small-min.9cbd93bd.png";